import { HeadingProps } from '.';

// This object should contain a mock value for each required prop of this component
export const requiredProps: HeadingProps = {};

// This array should contain an object only for tests you wish to run on all compliance tests
const sharedTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
    } as HeadingProps,
  },
];

export const testkitTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
      light: false,
      appearance: 'H1',
      children: 'Hey there, good looking',
    } as HeadingProps,
  },
];

export const ssrTests = [...sharedTests];

export const a11yTests = [...sharedTests];
